import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowDown, ArrowUpRight } from 'lucide-react';
import { useProducts } from '@/lib/shopify';

export const FashionHero = () => {
  const { products } = useProducts();
  const heroProduct = products[0];
  return (
  <section id="fashion-hero" className="relative h-[180svh] bg-[#F2F3F0]/45" data-testid="hero-section">
    <div className="sticky top-0 h-screen overflow-hidden">
      {heroProduct && <img
        src={heroProduct.image}
        alt={heroProduct.name}
        className="absolute inset-0 h-full w-full object-contain object-center opacity-45"
        data-testid="hero-shopify-image"
      />}
      <div className="absolute inset-0 bg-white/25" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#F7F7F3]/90 via-transparent to-white/35" />
    <div className="relative z-10 flex h-full flex-col justify-between px-5 pb-8 pt-32 sm:px-8 lg:px-12">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.25 }}
        className="flex flex-wrap items-center justify-between gap-4"
      >
        <p className="font-mono2 text-[10px] font-bold uppercase tracking-[0.28em] text-[#1E1E1E]">
          Drop 04 / Soft Structure
        </p>
        <p className="bg-[#C7D1C3] px-3 py-2 font-mono2 text-[9px] font-bold uppercase tracking-[0.22em] text-[#1E1E1E]">
          Limited run — no restocks
        </p>
      </motion.div>

      <div className="max-w-5xl">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.45 }}
          className="mb-5 max-w-sm text-sm leading-relaxed text-[#454545]"
        >
          Clothes for gallery afternoons, long lunches, and plans that become stories.
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.55, ease: [0.16, 1, 0.3, 1] }}
          className="font-syne text-4xl font-extrabold uppercase leading-[0.88] text-[#1E1E1E] sm:text-5xl lg:text-6xl"
          data-testid="hero-title"
        >
          Aura Studio<br /><span className="sage-text">98</span>
        </motion.h1>
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.8 }}
          className="mt-8 flex flex-wrap items-center gap-3"
        >
          <Link
            to="/shop"
            data-testid="hero-shop-button"
            className="group inline-flex items-center gap-3 bg-[#1E1E1E] px-6 py-4 font-syne text-xs font-bold uppercase text-white transition-[background-color,transform] duration-300 hover:-translate-y-1 hover:bg-[#657260]"
          >
            Shop Drop 04
            <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:rotate-45" />
          </Link>
          <Link
            to="/story"
            data-testid="hero-story-button"
            className="inline-flex items-center border border-[#1E1E1E] bg-white/80 px-6 py-4 font-syne text-xs font-bold uppercase text-[#1E1E1E] transition-colors duration-300 hover:bg-[#C7D1C3]"
          >
            Read our story
          </Link>
        </motion.div>
      </div>

      <div className="flex items-end justify-between">
        <p className="font-mono2 text-[9px] uppercase tracking-[0.25em] text-[#5C5C5C]">Seoul / Milan / Everywhere</p>
        <div className="flex items-center gap-2 font-mono2 text-[9px] uppercase tracking-[0.25em] text-[#5C5C5C]">
          Shape the look <ArrowDown size={13} />
        </div>
      </div>
    </div>
    </div>
  </section>
  );
};